
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","id":"Scissors-2--Streamline-Streamline--3.0.svg","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('desc',[_v('Scissors 2 Streamline Icon: https://streamlinehq.com')]),_c('g',[_c('path',{attrs:{"d":"M0.75 19.5a3.75 3.75 0 1 0 7.5 0 3.75 3.75 0 1 0 -7.5 0","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M0.75 4.5a3.75 3.75 0 1 0 7.5 0 3.75 3.75 0 1 0 -7.5 0","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M23.25 20.25 2.88 7.88","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M23.25 3.75 2.88 16.11","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])
          )
        }
      }
    